export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_03.ccb470d5.png";